let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7QqkI")).then(() => parcelRequire('cppNo'));